import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getAgentBranchDocument = id => {
  return http.get(
    `${getBaseUrl()}/agent_branch_document/${id}`
  );
};

export const getAgentBranchDocuments = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/agent_branch_document`
    );
  }
  return http.get(
    `${getBaseUrl()}/agent_branch_document?${paginate}`
  );
};

export const updateAgentBranchDocument = data => {

  return http.put(
    `${getBaseUrl()}/agent_branch_document/${data.id}`,
    data
  );
};
export const submitAgentBranchDocument = data => {

  return http.post(
    `${getBaseUrl()}/agent_branch_document`,
    data
  );
};
